// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper,
.card2 h2,
.card3 h2,
.trainers,
.testimonials_container,
.shop_now {
  text-align: center;
}

.shop_now h2:first-child,
.explore_container h2:first-child,
.home_page_form_row h2 {
  font-size: var(--hSize);
  color: #264ec8;
}
.explore_container h2:first-child {
  font-size: 2rem;
  text-transform: capitalize;
}
.shop_now h2:first-child span,
.explore_container h2:first-child span,
.home_page_form_row h2 span {
  color: #e20f6f;
}

.shop_now .Trainers_container h2 {
  text-align: center;
  font-size: 25px;
}

.shop_now .Trainers_container img {
  border-radius: 15px;
  height: 350px;
  width: 100%;
  object-fit: cover;
}

/* testimonials */
.TestimonialCarousel_value .col-md-6:first-child .testimonials_item {
  background: #fff1f900;
}

.TestimonialCarousel_value .col-md-6:last-child .testimonials_item {
  background: rgb(195 197 248 / 0%);
}
.our_partners .item img {
  height: 95px;
  object-fit: contain;
}

.kNBmiK {
  overflow: hidden;
  margin: 0px 0px 0px 0px !important;
}
.card2 .custom-tab.homepage-tab.tab-list {
  background: transparent;
}
.homepage-tab {
  align-items: center;
}
.homepage-tab li {
  padding: 10px 33px !important;
}
.featured-container .owl-carousel .owl-stage-outer {
  padding: 20px 0px;
}

.homepag-video-testim {
  background-color: #f5f6fb;
}
.homepag-video-testim .owl-theme .owl-nav {
  display: none;
}

.custom-card-padding h2 {
  padding: 20px 55px !important;
}



@media (max-width: 1024px) {
  .custm-ptb h2 {
    padding: 30px 5px !important;
  }
}

@media (max-width: 576px) {
  .card2 .custom-tab.homepage-tab.tab-list {
    background: transparent;
    column-gap: 0px;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
  .card2 .custom-tab.homepage-tab.tab-list li {
    margin-bottom: 20px;
    margin-left: 20px;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
  }
  .shop_now .Trainers_container img {
    height: 200px;
  }
  .homepage-tab li {
    padding: 5px 15px !important;
  }

  .featured-container .owl-carousel .owl-stage-outer {
    padding: 0;
    padding: initial;
  }
}
@media only screen and (min-width: 576px) and (max-width: 992px) {
  .card1 .row .col-lg-3:last-child .cardHome {
    display: none;
  }
  .shop_now .Trainers_container img {
    height: 250px;
  }
  .card2 .custom-tab.homepage-tab.tab-list {
    flex-wrap: wrap;
    justify-content: center;
  }
  .homepage-tab li.active,
  .homepage-tab li {
    width: auto !important;
    margin-bottom: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/home.css"],"names":[],"mappings":"AAAA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;;EAGE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,eAAe;EACf,0BAA0B;AAC5B;AACA;;;EAGE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;;;AAIA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,0BAAkB;IAAlB,uBAAkB;IAAlB,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,4BAA4B;EAC9B;;EAEA;IACE,UAAc;IAAd,gBAAc;EAChB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;;IAEE,sBAAsB;IACtB,mBAAmB;EACrB;AACF","sourcesContent":[".wrapper,\r\n.card2 h2,\r\n.card3 h2,\r\n.trainers,\r\n.testimonials_container,\r\n.shop_now {\r\n  text-align: center;\r\n}\r\n\r\n.shop_now h2:first-child,\r\n.explore_container h2:first-child,\r\n.home_page_form_row h2 {\r\n  font-size: var(--hSize);\r\n  color: #264ec8;\r\n}\r\n.explore_container h2:first-child {\r\n  font-size: 2rem;\r\n  text-transform: capitalize;\r\n}\r\n.shop_now h2:first-child span,\r\n.explore_container h2:first-child span,\r\n.home_page_form_row h2 span {\r\n  color: #e20f6f;\r\n}\r\n\r\n.shop_now .Trainers_container h2 {\r\n  text-align: center;\r\n  font-size: 25px;\r\n}\r\n\r\n.shop_now .Trainers_container img {\r\n  border-radius: 15px;\r\n  height: 350px;\r\n  width: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n/* testimonials */\r\n.TestimonialCarousel_value .col-md-6:first-child .testimonials_item {\r\n  background: #fff1f900;\r\n}\r\n\r\n.TestimonialCarousel_value .col-md-6:last-child .testimonials_item {\r\n  background: rgb(195 197 248 / 0%);\r\n}\r\n.our_partners .item img {\r\n  height: 95px;\r\n  object-fit: contain;\r\n}\r\n\r\n.kNBmiK {\r\n  overflow: hidden;\r\n  margin: 0px 0px 0px 0px !important;\r\n}\r\n.card2 .custom-tab.homepage-tab.tab-list {\r\n  background: transparent;\r\n}\r\n.homepage-tab {\r\n  align-items: center;\r\n}\r\n.homepage-tab li {\r\n  padding: 10px 33px !important;\r\n}\r\n.featured-container .owl-carousel .owl-stage-outer {\r\n  padding: 20px 0px;\r\n}\r\n\r\n.homepag-video-testim {\r\n  background-color: #f5f6fb;\r\n}\r\n.homepag-video-testim .owl-theme .owl-nav {\r\n  display: none;\r\n}\r\n\r\n.custom-card-padding h2 {\r\n  padding: 20px 55px !important;\r\n}\r\n\r\n\r\n\r\n@media (max-width: 1024px) {\r\n  .custm-ptb h2 {\r\n    padding: 30px 5px !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .card2 .custom-tab.homepage-tab.tab-list {\r\n    background: transparent;\r\n    column-gap: 0px;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  .card2 .custom-tab.homepage-tab.tab-list li {\r\n    margin-bottom: 20px;\r\n    margin-left: 20px;\r\n    width: fit-content;\r\n  }\r\n  .shop_now .Trainers_container img {\r\n    height: 200px;\r\n  }\r\n  .homepage-tab li {\r\n    padding: 5px 15px !important;\r\n  }\r\n\r\n  .featured-container .owl-carousel .owl-stage-outer {\r\n    padding: unset;\r\n  }\r\n}\r\n@media only screen and (min-width: 576px) and (max-width: 992px) {\r\n  .card1 .row .col-lg-3:last-child .cardHome {\r\n    display: none;\r\n  }\r\n  .shop_now .Trainers_container img {\r\n    height: 250px;\r\n  }\r\n  .card2 .custom-tab.homepage-tab.tab-list {\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n  }\r\n  .homepage-tab li.active,\r\n  .homepage-tab li {\r\n    width: auto !important;\r\n    margin-bottom: 20px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
